const NODE_ENV = process.env.NODE_ENV || "development";
const IS_TEST = NODE_ENV === "test";
const IS_PRODUCTION_NODE = NODE_ENV === "production";
const IS_DEVELOPMENT_NODE = NODE_ENV === "development";
const IS_PRODUCTION_DEPLOYMENT = process.env.DEPLOY_ENVIRONMENT === "production" || process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === "production";
const DEPLOY_ENVIRONMENT_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT || process.env.DEPLOY_ENVIRONMENT || (NODE_ENV === "development" ? "development" : (() => {
  throw Error("DEPLOY ENVIRONMENT NOT SPECIFIED!");
})());
const ENVIRONMENT = ["production", "preview", "development", "staging"].find(
  (v) => v === DEPLOY_ENVIRONMENT_ENV
) || (() => {
  throw Error(
    `Invalid DEPLOY_ENVIRONMENT value: ${DEPLOY_ENVIRONMENT_ENV}, expected: 'production' | 'preview' | 'staging' | 'development'`
  );
})();
const IS_DEVELOPMENT = ENVIRONMENT === "development";
const IS_STAGING_SNAPSHOT = process.env.IS_STAGING_SNAPSHOT === "true";

export { ENVIRONMENT as DEPLOY_ENVIRONMENT, ENVIRONMENT, IS_DEVELOPMENT, IS_DEVELOPMENT_NODE, IS_PRODUCTION_DEPLOYMENT, IS_PRODUCTION_NODE, IS_STAGING_SNAPSHOT, IS_TEST, NODE_ENV };
